import { css } from '@emotion/react';
import styled from '@emotion/styled';

export default function SetAICharacterCard() {
  return (
    <CharacterCard>
      <CharacterDetail>
        <div className='t' />

        <div className='desc'>
          <div className='d' />
          <div className='s' />
        </div>

        <div className='n' />
      </CharacterDetail>

      <ImageWrapper />
    </CharacterCard>
  );
}

export const CharacterCard = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    justify-content: space-between;
    width: 100%;
    height: 112px;
    padding: 8px;
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_dark_2};
    gap: 8px;
  `}
`;

export const CharacterDetail = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    height: 100%;

    .t {
      width: 35%;
      height: 20px;
      border-radius: 2px;
      background: ${theme.backgroundColor.bg_light_5_alpha};
    }

    .desc {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .d {
        width: 65%;
        height: 14px;
        border-radius: 2px;
        background: ${theme.backgroundColor.bg_light_5_alpha};
      }

      .s {
        width: 50%;
        height: 14px;
        border-radius: 2px;
        background: ${theme.backgroundColor.bg_light_5_alpha};
      }
    }

    .n {
      width: 25%;
      height: 14px;
      border-radius: 2px;
      background: ${theme.backgroundColor.bg_light_5_alpha};
    }
  `}
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 80px;
    height: 100%;
    border-radius: 4px;
    background: ${theme.backgroundColor.bg_light_5_alpha};

    img {
      width: 100%;
      height: 100%;
    }
  `}
`;
